import React from 'react'
import { Row, Col, FormGroup, Input } from 'reactstrap'
import Inputy from 'components/form/Input'

export default function TestItem({ mergetag, required }) {
  return <Row>
    <Col sm='6'>
      <FormGroup>
        <Input disabled value={mergetag} />
      </FormGroup>
    </Col>
    <Col sm='6'>
      <FormGroup>
        <Inputy
          name={`test[${mergetag}]`}
          placeholder="test value"
        />
      </FormGroup>
    </Col>
  </Row>
}